import { useState } from 'react';
import styles from './ThresholdSlider.module.css';

export default function ThresholdSlider({className,thresValue,setThresValue}){

  const clamp = (val) => {
    const num = parseFloat(val);
    if (isNaN(num)) return 0;
    return Math.min(Math.max(num, 0), 1);
  };

  const handleChange = (e) => {
    const val = clamp(e.target.value);
    setThresValue(Number(val.toFixed(3)));
  };

  return (
    <div className={`${styles.sliderWrapper} ${className}`}>
      <label htmlFor="threshold" className={styles.label}>
        Threshold 
        {/* <span className={styles.value}>{value.toFixed(3)}</span> */}
      </label>
    <input
        type="number"
        min="0"
        max="1"
        step="0.001"
        value={thresValue}
        onChange={handleChange}
        className={styles.numberInput}
      />
      <input
        id="threshold"
        type="range"
        min="0"
        max="1"
        step="0.001"
        value={thresValue}
        onChange={handleChange}
        onDoubleClick={()=>setThresValue(0.965)}
        className={styles.range}
      />
    </div>
  );
};